import React from 'react';

import { Box, Flex, Tooltip } from '@chakra-ui/react';
import useOKRConfig from 'components/hooks/useOKRConfig';

import { OBJECTIVE_TYPES_MAP, OKR_TYPES } from 'constants/ProjectConstants';

import { Avatar } from 'uiToolkitV1/Avatar';
import { AvatarGroup } from 'uiToolkitV1/AvatarGroup';

const OwnersAndCollaborators = ({ data }) => {
  const { toIds = [], type } = data ?? {};

  const isObjective = type === OKR_TYPES.OBJECTIVE;

  /* 
    config based changes
    requirement: for simple objective type hide owners and collaborators field.
  */
  const { OBJECTIVE_TYPE } = useOKRConfig();

  const isSimpleObjectiveType = OBJECTIVE_TYPE === OBJECTIVE_TYPES_MAP.SIMPLE.value;

  const hideOwnersAndCollaborators = isObjective && isSimpleObjectiveType;

  if (hideOwnersAndCollaborators) return null;

  /* config based changes end */

  return (
    <Box
      height="100%"
      sx={{
        '.chakra-avatar__group': {
          height: '100% !important',
        },
        '.chakra-avatar': {
          marginRight: '4px',
        },
      }}
    >
      <AvatarGroup>
        {toIds?.map(({ displayName, profilePhoto, ownerType }, index) => (
          <Tooltip
            key={index}
            sx={{
              background: '#595E6A',
              fontSize: '12px',
              color: '#ffffff',
              border: ownerType === 'COLLABORATOR' ? null : '2px solid green',
            }}
            label={displayName}
          >
            <Flex>
              <Avatar name={displayName} src={profilePhoto} />
            </Flex>
          </Tooltip>
        ))}
      </AvatarGroup>
    </Box>
  );
};

export { OwnersAndCollaborators };
